// extracted by mini-css-extract-plugin
export var component = "NoticeModule-module--component--GwXhi";
export var content = "NoticeModule-module--content--66olW";
export var hasIcon = "NoticeModule-module--hasIcon--2QXCf";
export var icon = "NoticeModule-module--icon--ZjQg0";
export var title = "NoticeModule-module--title--DlZT3";